// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"UploadRentRoll_pageWrapper__D2H9z","headerWrapper":"UploadRentRoll_headerWrapper__3QwgB"};